// src/components/Card/Hierarchy/HierarchyCard.jsx
//
// Mismo tratamiento visual que OfficeCard (misma familia de superficie),
// sin badge de rol ni acciones -- la jerarquía siempre navega a edición.

import React from 'react';
import { Paper, Box, Typography, Avatar, Chip } from '@mui/material';
import { tokens, gradientForName } from '../../../theme/tokens';
import { useNavigate } from 'react-router-dom';

const HierarchyCard = ({ hierarchy }) => {
  const navigate = useNavigate();
  const handleClick = () => navigate(`/hierarchy/${hierarchy.id}/edit`);

  const formsCount = hierarchy.hierarchy_form?.length || 0;
  const typesCount =
    hierarchy.hierarchy_form?.reduce(
      (acc, form) => acc + (form.case_type?.length || 0),
      0
    ) || 0;

  return (
    <Paper
      onClick={handleClick}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        cursor: 'pointer',
        borderRadius: `${tokens.radius.lg}px`,
        p: 3,
        transition: '.18s',
        '&:hover': { transform: 'translateY(-3px)', borderColor: tokens.colors.line2 },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: 4,
          backgroundImage: tokens.gradient.main,
        }}
      />

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Avatar
          sx={{
            width: 56,
            height: 56,
            borderRadius: '16px',
            fontWeight: 800,
            fontSize: '1.1rem',
            backgroundImage: gradientForName(hierarchy.name || ''),
          }}
        >
          {hierarchy.name?.charAt(0)?.toUpperCase()}
        </Avatar>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography variant="h6" fontWeight={720} noWrap>
            {hierarchy.name}
          </Typography>
          <Typography variant="body2" color="text.secondary" noWrap>
            {hierarchy.practice_area?.name || 'Sin área'}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', gap: 1, pt: 1.5, borderTop: `1px solid ${tokens.colors.line}` }}>
        <Chip label={`${formsCount} formas`} size="small" />
        <Chip label={`${typesCount} tipos`} size="small" />
      </Box>
    </Paper>
  );
};

export default HierarchyCard; 